import { h } from '@stencil/core';
import reelsModal from 'store/reelsModal';
import { triggerTrackEvent } from 'utils/events';

const onClose = () => {
  reelsModal.isOpen = false;
  reelsModal.index = -1;

  triggerTrackEvent({
    event_type: 'user',
    event_name: 'close_reel',
  });
};

const onKeyDown = event => {
  if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
    event.preventDefault();
    const newIndex = Math.min(reelsModal.videos.length - 1, reelsModal.index + 1);

    if (reelsModal.index !== newIndex) {
      triggerTrackEvent({
        event_type: 'user',
        event_name: 'next_reel_keyboard',
      });
    }

    reelsModal.index = newIndex;
  } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
    event.preventDefault();
    const newIndex = Math.max(0, reelsModal.index - 1);

    if (reelsModal.index !== newIndex) {
      triggerTrackEvent({
        event_type: 'user',
        event_name: 'prev_reel_keyboard',
      });
    }

    reelsModal.index = newIndex;
  } else if (event.key === 'Escape') {
    event.preventDefault();
    onClose();
  }
};

const onScrollEnd = event => {
  const videoPlayerModal = document.querySelector('#video-player-modal');
  if (videoPlayerModal !== null) {
    reelsModal.index = videoPlayerModal.scrollTop / window.innerHeight;
  }
};

export default function VideoPlayerModal({ show }: { show: boolean }) {
  document[show ? 'addEventListener' : 'removeEventListener']('keydown', onKeyDown);

  setTimeout(() => {
    document.querySelector('#video-player-modal')?.[show ? 'addEventListener' : 'removeEventListener']('scrollend', onScrollEnd);
    document.querySelector('#video-player-modal')?.[show ? 'addEventListener' : 'removeEventListener']('touchend', onScrollEnd);
  }, 250);

  return show ? (
    <div id="video-player-modal" role="presentation" class="eva-3-modal -sm -show-sticky-footer -smooth-scroll fullscreen-modal -show-modal" onClick={onClose}>
      <div class="close-video-player" onClick={onClose}>
        <i class="eva-3-icon-cross -eva-3-icon-md"></i>
      </div>

      {reelsModal.videos.map((v, index) => (
        <video id={`video-player-${index}`} controls loop muted onClick={e => e.stopPropagation()}>
          <source type="video/mp4" src={`https://media.staticontent.com/media/documents/${v.src[0]}`} />
        </video>
      ))}
    </div>
  ) : null;
}
